import { FiMenu } from 'react-icons/fi';

import { SecondaryButton } from './SecondaryButton';

type MenuButtonProps = {
  size?: number;
  onClick?: () => void;
};

export function MenuButton({ size = 20, onClick }: MenuButtonProps) {
  return (
    <SecondaryButton
      ariaLabel="Open menu"
      onClick={onClick}
      variant="medium"
      style={{
        height: 'var(--nn-control-height-sm)',
        // padding: 0,
        // width: 'var(--nn-control-height-md)',
      }}
    >
      <FiMenu size={size} aria-hidden />
    </SecondaryButton>
  );
}
